"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationError = exports.ResourceNotFoundError = void 0;
exports.isResourceNotFoundError = isResourceNotFoundError;
exports.isValidationError = isValidationError;
class ResourceNotFoundError extends Error {
    constructor(kind, id) {
        super(`${kind} not found: ${id}`);
        this.kind = kind;
        this.id = id;
        this.name = this.constructor.name;
    }
}
exports.ResourceNotFoundError = ResourceNotFoundError;
class ValidationError extends Error {
    constructor(message) {
        super(message);
        this.name = this.constructor.name;
    }
}
exports.ValidationError = ValidationError;
function isResourceNotFoundError(error) {
    return error instanceof ResourceNotFoundError;
}
function isValidationError(error) {
    return error instanceof ValidationError;
}
//# sourceMappingURL=domain.errors.js.map